import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import moment from "moment";
import ExpandDiv from "./../common/ExpandDiv";
import Select from "./../common/Select";
import Input from "./../common/Input";
import SearchBox from "./../common/SearchBox";
import {
  getGroupSupervisionLogs,
  saveGroupSupervisionLog,
} from "./../services/soar";

function GroupSupervisions({ safyUsers, provider }) {
  const isMountedRef = useRef(true);
  const [data, setData] = useState({});
  const [logs, setLogs] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loadStatus, setLoadStatus] = useState({});
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const navigate = useNavigate();

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    if (loadStatus.loaded || loadStatus.loading || !provider.domainName) {
      return;
    }

    const loadLogs = async () => {
      setLoadStatus({ loading: true });
      const response = await getGroupSupervisionLogs(provider.domainName);

      if (!isMountedRef.current) {
        return;
      }

      if (response) {
        setLogs(response);
      }

      setLoadStatus({ loaded: true });
    };

    loadLogs();
  }, [provider.domainName, loadStatus]);

  const handleDataChange = ({ currentTarget: input }) => {
    const obj = { ...data };
    obj[input.name] = input.type === "checkbox" ? input.checked : input.value;
    setData(obj);
  };

  const filterMyLogs = () => {
    let filtered = logs;
    if (data.mySearchQuery) {
      filtered = filtered.filter(
        (item) =>
          (item.SuperviseeName &&
            item.SuperviseeName.toLowerCase().includes(
              data.mySearchQuery.toLowerCase()
            )) ||
          (item.SupervisorName &&
            item.SupervisorName.toLowerCase().includes(
              data.mySearchQuery.toLowerCase()
            ))
      );
    }

    if (data.myBeginDate && data.myBeginDate !== "") {
      filtered = filtered.filter(
        (item) => new Date(item.DateCompleted) >= new Date(data.myBeginDate) - 1
      );
    }

    if (data.myEndDate && data.myEndDate !== "") {
      filtered = filtered.filter(
        (item) => new Date(item.DateCompleted) <= new Date(data.myEndDate)
      );
    }
    return filtered;
  };

  // const filterSuperviseeLogs = () => {
  //   let filtered = logs;
  //   if (data.superviseeSearchQuery) {
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.SupervisorName &&
  //         item.SupervisorName.toLowerCase().includes(
  //           data.superviseeSearchQuery.toLowerCase()
  //         )
  //     );
  //   }

  //   if (data.superviseeBeginDate && data.superviseeBeginDate !== "") {
  //     filtered = filtered.filter(
  //       (item) =>
  //         new Date(item.DateCompleted) >= new Date(data.superviseeBeginDate) - 1
  //     );
  //   }

  //   if (data.superviseeEndDate && data.superviseeEndDate !== "") {
  //     filtered = filtered.filter(
  //       (item) =>
  //         new Date(item.DateCompleted) <= new Date(data.superviseeEndDate)
  //     );
  //   }
  //   return filtered;
  // };

  const createLog = () => {
    if (data.selectedSupervisor) {
      const supervisor = safyUsers.filter(
        (user) => user._id === data.selectedSupervisor
      )[0];
      const obj = {
        LogId: null,
        SuperviseeUser: safyInfo.user.domainName.split("\\")[1],
        SuperviseeName: safyInfo.user.displayName,
        SupervisorUser: `${supervisor._id.split("@")[0]}`,
        SupervisorName: supervisor.firstLast,
        DateCompleted: new Date(),
        LengthOfSupervision: null,
        CountsAsLicensure: 0,
        LengthOfLicensure: null,
        CaseReviews: null,
        IdentifiedResources: null,
        Other: null,
        Comments: "<comments></comments>",
        Signatures:
          "<signatures><type>Supervisor</type></signatures><signatures><type>Supervisee</type></signatures>",
        CreatedById: safyInfo.user.domainName.split("\\")[1],
        ModifiedById: safyInfo.user.domainName.split("\\")[1],
      };
      saveGroupSupervisionLog(obj, "Insert").then((response) => {
        if (isMountedRef.current) {
          setIsOpen(false);
        }
        const r = JSON.parse(response);
        if (
          r &&
          r.SystemResponse &&
          r.SystemResponse[0] &&
          r.SystemResponse[0].Id
        ) {
          navigate(`/groupsupervision/${r.SystemResponse[0].Id}`);
        }
      });
    } else {
      toast.error("You must select a person");
    }
  };

  return (
    <>
      {isOpen ? (
        <>
          <Modal show={isOpen} animation={false}>
            <Modal.Header className="bg-safy3-1">
              <Modal.Title>New Group Supervision Log</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <SearchBox
                divClassName="mb-4"
                name="employeeQuery"
                label="Search for Supervisor by Name"
                value={data.employeeQuery}
                onChange={handleDataChange}
                clearSearch={() => {
                  const obj = { ...data };
                  obj.employeeQuery = "";
                  setData(obj);
                }}
              />
              <Select
                name="selectedSupervisor"
                label="Select the supervisor for the group supervision log"
                onChange={handleDataChange}
                value={data.selectedSupervisor}
                options={
                  data.employeeQuery
                    ? safyUsers.filter(
                      (e) =>
                        e.name &&
                        e.name
                          .toLowerCase()
                          .includes(data.employeeQuery.toLowerCase())
                    )
                    : safyUsers
                }
              />
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-danger"
                onClick={() => {
                  const obj = { ...data };
                  delete obj.employeeQuery;
                  setData(obj);
                  setIsOpen(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  createLog();
                }}
              >
                Submit
              </button>
            </Modal.Footer>
          </Modal>
        </>
      ) : null}
      <ExpandDiv
        className="border rounded p-2 mb-4 card-safy"
        title="Group Supervisions"
      >
        <div className="row">
          <div className="col-9"></div>
          <div
            className="col-2 btn btn-primary btn-sm"
            onClick={() => setIsOpen(!isOpen)}
          >
            Create
            <br />
            Group Supervision Log
          </div>
        </div>
        <div className="row ms-2 mt-2">
          <div className="col-6">
            <SearchBox
              name="mySearchQuery"
              label="Search by Supervisor Name"
              value={data.mySearchQuery}
              onChange={handleDataChange}
              clearSearch={() => {
                const obj = { ...data };
                obj.mySearchQuery = "";
                setData(obj);
              }}
            />
          </div>
          <div className="col-3">
            <Input
              name="myBeginDate"
              type="date"
              label="Begin Date"
              value={data.myBeginDate}
              onChange={handleDataChange}
            />
          </div>
          <div className="col-3">
            <Input
              name="myEndDate"
              type="date"
              label="End Date"
              value={data.myEndDate}
              onChange={handleDataChange}
            />
          </div>
        </div>

        {filterMyLogs()
          .filter(
            (l) =>
              l.SuperviseeUser.toLowerCase() ===
              provider.domainName.toLowerCase() ||
              (l.SupervisorUser.toLowerCase() ===
                provider.domainName.toLowerCase() &&
                l.Signatures &&
                l.Signatures.signatures &&
                l.Signatures.signatures[1] &&
                l.Signatures.signatures[1].date)
          )
          .map((log, index) => {
            const color =
              log.SuperviseeUser === provider.domainName
                ? "bg-safy2-1"
                : "bg-safy3-1";
            return (
              <div key={`gl${index}`}>
                <div
                  className={`border border-dark rounded px-4 py-2 m-2 text-white card-safy row ${color}`}
                >
                  <div className="col-3">
                    <div>Supervisee:</div>
                    <div>{log.SuperviseeName}</div>
                  </div>
                  <div className="col-3">
                    <div>Supervisor:</div>
                    <div>{log.SupervisorName}</div>
                  </div>
                  <div className="col-2">
                    {log.DateCompleted
                      ? moment.utc(log.DateCompleted).format("MMMM Do YYYY")
                      : ""}
                  </div>
                  <div className="col-3">
                    {log.Signatures &&
                      log.Signatures.signatures &&
                      log.Signatures.signatures[0] &&
                      log.Signatures.signatures[0].date ? (
                      <div className="m-0">Supervisor: Signed</div>
                    ) : (
                      <div className="m-0">Supervisor: Not Signed</div>
                    )}
                    {log.Signatures &&
                      log.Signatures.signatures &&
                      log.Signatures.signatures[1] &&
                      log.Signatures.signatures[1].date ? (
                      <div className="m-0">Supervisee: Signed</div>
                    ) : (
                      <div className="m-0">Supervisee: Not Signed</div>
                    )}
                  </div>
                  <div className="col-1">
                    <Link
                      title="Supervision Log"
                      to={`/groupsupervision/${log.LogId}`}
                    >
                      <i className="fas fa-pen float-end p-2 text-white"></i>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
      </ExpandDiv>

      {/* <ExpandDiv
        className="border rounded p-2 mb-4"
        title="Logs Submitted to Me"
      >
        <div className="row ms-2 mt-2">
          <div className="col-6">
            <SearchBox
              name="superviseeSearchQuery"
              label="Search by Supervisor Name"
              value={data.superviseeSearchQuery}
              onChange={handleDataChange}
            />
          </div>
          <div className="col-3">
            <Input
              name="superviseeBeginDate"
              type="date"
              label="Begin Date"
              value={data.superviseeBeginDate}
              onChange={handleDataChange}
            />
          </div>
          <div className="col-3">
            <Input
              name="superviseeEndDate"
              type="date"
              label="End Date"
              value={data.superviseeEndDate}
              onChange={handleDataChange}
            />
          </div>
        </div>
        {filterSuperviseeLogs()
          .filter(
            (l) =>
              l.SupervisorUser === safyInfo.user.domainName.split("\\")[1] &&
              l.Signatures &&
              l.Signatures.signatures &&
              l.Signatures.signatures[1] &&
              l.Signatures.signatures[1].date
          )
          .map((log) => (
            <>
              <div className="border border-dark rounded px-4 py-2 m-2 text-white card-safy bg-safy3-1 row">
                <div className="col-3">
                  <div>Supervisee:</div>
                  <div>{log.SuperviseeName}</div>
                </div>
                <div className="col-3">
                  <div>Supervisor:</div>
                  <div>{log.SupervisorName}</div>
                </div>
                <div className="col-2">
                  {log.DateCompleted
                    ? moment.utc(log.DateCompleted).format("MMMM Do YYYY")
                    : ""}
                </div>
                <div className="col-3">
                  {log.Signatures &&
                  log.Signatures.signatures &&
                  log.Signatures.signatures[0] &&
                  log.Signatures.signatures[0].date ? (
                    <div className="m-0">Supervisor: Signed</div>
                  ) : (
                    <div className="m-0">Supervisor: Not Signed</div>
                  )}
                  {log.Signatures &&
                  log.Signatures.signatures &&
                  log.Signatures.signatures[1] &&
                  log.Signatures.signatures[1].date ? (
                    <div className="m-0">Supervisee: Signed</div>
                  ) : (
                    <div className="m-0">Supervisee: Not Signed</div>
                  )}
                </div>
                <div className="col-1">
                  <Link
                    title="Supervision Log"
                    to={{
                      pathname: `/groupsupervision/${log.LogId}`,
                    }}
                  >
                    <i className="fas fa-pen float-end p-2 text-white"></i>
                  </Link>
                </div>
              </div>
            </>
          ))}
      </ExpandDiv> */}
    </>
  );
}

export default GroupSupervisions;
